/* eslint-disable react/no-array-index-key */

import styled from 'styled-components';
import type { ProductListItemModel } from 'autogen/swagger/all';
import { PictogramSplash, TagSplash } from 'components/shared/Splash';

export const SplashOverlayContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    padding: ${({ theme }) => theme.Spacing8};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.Spacing8};
    opacity: 1;
    transition: opacity ease 0.2s;
    justify-content: end;
    align-items: start;
    z-index: 1;
`;

const PictogramContainer = styled.div`
    display: grid;
    align-content: end;
    gap: ${({ theme }) => theme.Spacing2};
`;

export default function SplashOverlay(splashes: ProductListItemModel['splashes']) {
    const { extra } = splashes;
    const hazardSplashes = extra.filter((splash) => splash.type === 'Hazard');
    const medicalSplash = extra.find((splash) => splash.type === 'OtcMinAge');

    return (
        <SplashOverlayContainer>
            {hazardSplashes.length > 0 && (
                <PictogramContainer>
                    {hazardSplashes.map((splash, index) => (
                        <PictogramSplash {...splash} key={index} />
                    ))}
                </PictogramContainer>
            )}

            {medicalSplash && <TagSplash {...medicalSplash} />}
        </SplashOverlayContainer>
    );
}
